var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer-blob"},[_c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
        callback: _vm.visibilityChanged,
        throttle: 300,
    }),expression:"{\n        callback: visibilityChanged,\n        throttle: 300,\n    }"}],ref:"scale",staticClass:"content-blob"},[_c('h2',[_vm._v(" "+_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.text))]),_c('h3',[_vm._v("Lees het verhaal!")])])])}
var staticRenderFns = []

export { render, staticRenderFns }